export var TextSizeType;
(function (TextSizeType) {
    TextSizeType["TEXT18"] = "text18";
    TextSizeType["TEXT16"] = "text16";
    TextSizeType["TEXT14"] = "text14";
    TextSizeType["TEXT12"] = "text12";
})(TextSizeType || (TextSizeType = {}));
//# sourceMappingURL=BaseText.enum.js.map